import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isMobileDevice } from '../deviceDetection';
import './MobileRedirect.css';

/**
 * Component that redirects mobile users away from restricted pages
 * or displays a message explaining why they can't access the page
 */
const MobileRedirect = ({ children }) => {
  const location = useLocation();
  const isMobile = isMobileDevice();
  const isRestrictedPath = location.pathname.includes('/board/');

  // If not mobile or not a restricted path, render children normally
  if (!isMobile || !isRestrictedPath) {
    return children;
  }

  // For mobile users trying to access board pages, show the mobile restriction message
  return (
    <div className="mobile-restriction">
      <div className="mobile-restriction-content">
        <h2>Desktop Only Feature</h2>
        <div className="mobile-icon">
          <i className="fas fa-desktop"></i>
          <i className="fas fa-ban"></i>
          <i className="fas fa-mobile-alt"></i>
        </div>
        <p>
          We're sorry, but the board editor is only available on desktop devices.
        </p>
        <p>
          The interactive board requires a larger screen for the best experience.
          Please visit this page on a desktop or laptop computer.
        </p>
        <button 
          className="back-button"
          onClick={() => window.history.back()}
        >
          Go Back
        </button>
        <button 
          className="dashboard-button"
          onClick={() => window.location.href = '/dashboard'}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default MobileRedirect;
